import { useTheme } from "@emotion/react";
import React, { useState } from "react";
import { capitalizeFirstLetter } from "../helpers/helpers";

const CcInput = ({ name, id, error, data, register, ...props}) => {
  const theme = useTheme();
  const [focused, setFocused] = useState(false);

  const fieldsetStyle = {
    border: 0,
    margin: 0,
    marginBottom: 12,
    padding: 0,
  };

  const labelStyle = {
    borderRadius: 3,
    color: "rgba(108, 117, 125, 0.6)",
    fontFamily: theme.font.primary,
    fontSize: theme.f_sizes.base - 1,
    lineHeight: 1,
    position: "absolute",
    top: "50%",
    left: 6,
    padding: 2,
    transform: "translateY(-50%)",
    transition: "all .2s ease-in-out",
    "&.focused": {
      backgroundColor: theme.colors.white,
      color: theme.colors.font,
      transform: "translateY(-160%)",
    }
  };

  const inputStyle = {
    backgroundColor: theme.colors.white,
    border: "1px solid #8c8c8c",
    borderRadius: 4,
    boxSizing: "border-box",
    color: theme.colors.font,
    fontFamily: theme.font.primary,
    fontSize: theme.f_sizes.base,
    padding: "0 8px",
    height: 30,
    width: "100%",
    "&:-webkit-autofill": {
      backgroundColor: `${theme.colors.white} !important`,
    },
    "&:focus": {
      outlineColor: theme.colors.primary,
    },
  };

  const errorStyle = {
    color: theme.colors.error,
    fontFamily: theme.font.secondary,
  };

  return(
    <fieldset css={fieldsetStyle}>
      <div css={{ position: "relative" }}>
        <label css={labelStyle} htmlFor={id} className={focused ? "focused" : ""}>
          {capitalizeFirstLetter(name).split("_").join(" ")}
        </label>
        <input
          css={inputStyle}
          type={data?.type || "text"}
          id={id}
          name={name}
          ref={register}
          {...props}
          onFocus={() => setFocused(true)}
          onBlur={(event) => setFocused(event.target.value.length > 0)}
        />
      </div>
      {error && <span css={errorStyle}>{error?.message}</span>}
    </fieldset>
  );
};

export default CcInput;
